import { api } from "@/lib/backend";
import { Capacitor } from "@/lib/capacitor";
import { Device } from "@/lib/capacitor/device";
import { PushNotifications } from "@/lib/capacitor/push-notifications";
import { logger } from "@/logger";

/**
 * Cleanup device registration from backend and unregister from push notifications Should be called
 * on logout to prevent notifications being sent to wrong user
 */
export async function cleanupDeviceRegistration() {
  if (Capacitor.Platform === "web") {
    logger.debug("Skipping device cleanup on web platform");
    return;
  }

  try {
    logger.info("Cleaning up device registration...");

    // Get current device identifier
    const deviceIdentifier = await Device.getDeviceIdentifier();

    // Unregister from push notifications (clears local state)
    await PushNotifications.unregister();
    logger.debug("Unregistered from push notifications locally");

    // Remove device from backend
    await api.notification.deleteDevice(deviceIdentifier);
    logger.info("Device registration cleaned up successfully", { deviceIdentifier });
  } catch (error) {
    // Don't throw - logout should proceed even if cleanup fails
    logger.error({ error }, "Failed to cleanup device registration");
  }
}

/** Register current device for push notifications Should be called after login and permission grant */
export async function registerDevice() {
  if (Capacitor.Platform === "web") {
    logger.debug("Skipping device registration on web platform");
    return;
  }

  try {
    logger.info("Registering device for push notifications...");

    // This will trigger the registration listener in NotificationListenerPush
    // which handles the backend API call
    await PushNotifications.register();

    logger.info("Device registration initiated");
  } catch (error) {
    logger.error({ error }, "Failed to register device");
    throw error;
  }
}
